import type { PathParam } from 'react-router-dom';
import { generatePath } from 'react-router-dom';

export const createRoute = <T extends string>(template: T) => {
  type Params = { [key in PathParam<T>]: string };

  return {
    template,
    path: (...args: [PathParam<T>] extends [never] ? [] : [params: Params]) =>
      generatePath(template, args[0] as { [key in PathParam<T>]: string | null } | undefined),
  };
};
